/**
 * Configuration validation utilities
 *
 * Provides validation functions to ensure SDK configuration is valid before initialization.
 */

import { LingDatabaseSDKConfig } from "../types/config";

/**
 * Validates SDK configuration parameters
 *
 * @param config - The configuration object to validate
 * @throws {Error} If any configuration parameter is invalid
 */
export function validateConfig(config: LingDatabaseSDKConfig): void {
  // Validate environment setting
  if (
    !config.environment ||
    (config.environment !== "test" && config.environment !== "production")
  ) {
    throw new Error('Environment must be either "test" or "production"');
  }

  // Validate auth token provider
  if (!config.getAuthToken || typeof config.getAuthToken !== "function") {
    throw new Error(
      "getAuthToken must be a function that returns a Promise<string>"
    );
  }

  // Validate custom endpoint format if provided
  if (
    config.customEndpoint &&
    !config.customEndpoint.includes("{{service-name}}")
  ) {
    throw new Error(
      "Custom endpoint must include {{service-name}} placeholder"
    );
  }
}

